import { ThemeProvider } from '@inflearn/ds-react';
import {
  ModalsProvider,
  NotificationsProvider,
  ThemeProvider as ThemeProviderNext,
} from '@inflearn/ds-react-next';
import { useLang } from '@inflearn/i18n-tools';
import type { ReactNode } from 'react';

import { NEXT_PUBLIC_CDN_URL } from '../../appConfig';
import { styleCache, styleCacheNext } from '../utils/emotionCache';

export function DsProvider({ children }: { children: ReactNode }) {
  const { lang } = useLang();

  return (
    <ThemeProviderNext cdnLink={NEXT_PUBLIC_CDN_URL || ''} emotionCache={styleCacheNext}>
      <ThemeProvider
        cdnLink={NEXT_PUBLIC_CDN_URL || ''}
        emotionCache={styleCache}
        lang={lang}
        withNormalizeCSS={false}
      >
        <NotificationsProvider />
        <ModalsProvider>{children}</ModalsProvider>
      </ThemeProvider>
    </ThemeProviderNext>
  );
}
